export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/arabic.c250dfe.svg";